import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

import config from '../config';

import { Layout } from '../pages/layout/Layout';
import HomePage from '../pages/HomePage';
import Menu from '../pages/Menu';
import CalculatePage from '../pages/CalculatePage';

import { Meet } from '../pages/meet/Meet';
import Match from '../pages/Match';
import Filters from '../pages/meet/Filters';

import Chats from '../pages/chats/Chats';
import ChatView from '../pages/chats/ChatView';
import VideoChat from '../pages/chats/VideoChat';

import Profile from '../pages/Profile';
import ProfileMenu from '../pages/profile-menu/ProfileMenu';
import ProfileEdit from '../pages/profile/ProfileEdit';
import Photo from '../pages/profile/Photo';
import Main from '../pages/profile/Main';
import MeetGoal from '../pages/profile/MeetGoal';
import Audio from '../pages/profile/Audio';
import About from '../pages/profile/About';
import Interests from '../pages/profile/Interests';
import DeleteProfile from '../pages/profile/DeleteProfile';
import ConfirmDeleteProfile from '../pages/profile/ConfirmDeleteProfile';

import Notifications from '../pages/notification/Notifications';
import Likes from '../pages/likes/Likes';
import Sympathies from '../pages/likes/Sympathies';
import Invite from '../pages/profile/Invite';
import MytaIdea from '../pages/MytaIdea';
import { Subscription } from '../pages/subscription/Subscription';
import NotificationSuperLikeProfile from '../components/notifications/NotificationSuperLikeProfile';

import Roulette from '../pages/roulette/Roulette';
import RouletteInstruction from '../pages/roulette/RouletteInstruction';
import Events from '../pages/events/Events';
import EventDetail from '../pages/events/EventDetail';
import EventsFilters from '../pages/events/EventsFilters';
import EventInvite from '../pages/events/EventInvite';
import EventParticipants from '../pages/events/EventParticipants';
import Streams from '../pages/streaming/Streams';
import StreamFilters from '../pages/streaming/StreamFilters';
import Streamer from '../pages/streaming/Streamer';
import StreamBroadcaster from '../pages/streaming/StreamBroadcaster';
import StreamViewer from '../pages/streaming/StreamViewer';
import InvitationHandler from '../pages/InvitationHandler';
import { ProfileChat } from '../pages/chats/ProfileChat';
import { Payment } from '../pages/payments/Payment';
import { SubscriptionSettings } from '../pages/subscription/SubscriptionSettings';
import { useEffect } from 'react';
import { SubscriptionTrial } from '../pages/subscription/SubscriptionTrial';
import { apiTrials } from '../api/apiTrials.api';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { toast } from 'react-toastify';
import BannedAccountScreen from '../components/BannedAccountScreen';
import { Paywall } from '../pages/subscription/Paywall';
import { SendGiftsUser } from '../pages/gifts/SendGiftsUser';

export function RouterProvider() {
  const location = useLocation();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    const code = tg?.initDataUnsafe?.start_param;

    if (!code) return;
    if (location.pathname.includes('premium-trial')) return;

    const used = sessionStorage.getItem('trial_used');
    if (used === code) return;

    apiTrials
      .checkAvailability(axiosPrivate, code)
      .then((res) => {
        if (res?.available) {
          sessionStorage.setItem('trial_used', code);
          navigate(config.ROUTES.PREMIUM_TRIAL(code));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Routes location={location}>
      <Route path={config.ROUTES.HOME} element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path={config.ROUTES.MENU} element={<Menu />} />
        <Route path={config.ROUTES.CALCULATE} element={<CalculatePage />} />
        <Route path={'/friendcode/:invite_id'} element={<InvitationHandler />} />
      </Route>

      <Route
        path={config.ROUTES.HOME}
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path={config.ROUTES.MEET} element={<Meet />} />
        <Route path={config.ROUTES.MATCH} element={<Match />} />
        <Route path={config.ROUTES.FILTERS} element={<Filters />} />

        {/* Streaming Features */}
        <Route path={config.ROUTES.STREAMS.LIST} element={<Streams />} />
        <Route path={config.ROUTES.STREAMS.FILTERS} element={<StreamFilters />} />
        <Route path={config.ROUTES.STREAMS.STREAMER_PROFILE(':id')} element={<Streamer />} />
        <Route path={config.ROUTES.STREAMS.BROADCASTER} element={<StreamBroadcaster />} />
        <Route path={config.ROUTES.STREAMS.WATCH(':id')} element={<StreamViewer />} />
        <Route path={config.ROUTES.ROULETTE} element={<Roulette />} />
        <Route path={config.ROUTES.ROULETTE_INSTRUCTION} element={<RouletteInstruction />} />

        {/* Мероприятия */}
        <Route path={config.ROUTES.EVENTS.LIST} element={<Events />} />
        <Route path={config.ROUTES.EVENTS.FILTERS} element={<EventsFilters />} />
        <Route path={config.ROUTES.EVENTS.INVITE(':id')} element={<EventInvite />} />
        <Route path={config.ROUTES.EVENTS.PARTICIPANTS(':id')} element={<EventParticipants />} />
        <Route path={config.ROUTES.EVENTS.DETAIL(':id')} element={<EventDetail />} />
        <Route path={config.ROUTES.CHATS.PROFILE(':id')} element={<ProfileChat />} />
        <Route path={config.ROUTES.CHATS.LIST} element={<Chats />} />
        <Route path={config.ROUTES.CHATS.TEXT(':chat_id')} element={<ChatView />} />
        <Route path={config.ROUTES.CHATS.VIDEO} element={<VideoChat />} />

        <Route path={config.ROUTES.PROFILE.VIEW} element={<Profile />} />
        <Route path={config.ROUTES.NOTIFICATIONS} element={<Notifications />} />
        <Route path={config.ROUTES.LIKES} element={<Likes />} />
        <Route path={config.ROUTES.SYMPATHIES} element={<Sympathies />} />
        <Route path={config.ROUTES.PROFILE_MENU} element={<ProfileMenu />} />
        <Route path={config.ROUTES.PROFILE.EDIT} element={<ProfileEdit />} />
        <Route path={config.ROUTES.PROFILE.PHOTO} element={<Photo />} />
        <Route path={config.ROUTES.PROFILE.MAIN} element={<Main />} />
        <Route path={config.ROUTES.PROFILE.MEET_GOAL} element={<MeetGoal />} />
        <Route path={config.ROUTES.PROFILE.AUDIO} element={<Audio />} />
        <Route path={config.ROUTES.PROFILE.ABOUT} element={<About />} />
        <Route path={config.ROUTES.PROFILE.INTERESTS} element={<Interests />} />
        <Route path={config.ROUTES.PROFILE.DELETE} element={<DeleteProfile />} />
        <Route path={config.ROUTES.PROFILE.CONFIRM_DELETE} element={<ConfirmDeleteProfile />} />
        <Route path={config.ROUTES.GIFTS.SEND} element={<SendGiftsUser />} />

        <Route
          path={config.ROUTES.MATCHS.SUPER_LIKE_PROFILE_ID(':id', ':notificationId')}
          element={<NotificationSuperLikeProfile />}
        />

        <Route path={config.ROUTES.PAYWALL} element={<Paywall />} />
        <Route path={config.ROUTES.INVITE} element={<Invite />} />
        <Route path={config.ROUTES.PAYMENT} element={<Payment />} />
        <Route path={config.ROUTES.PREMIUM} element={<Paywall />} />
        <Route path={config.ROUTES.PREMIUM_TRIAL(':trialId')} element={<SubscriptionTrial />} />
        <Route path={config.ROUTES.MYTA_IDEA} element={<MytaIdea />} />

        <Route path={config.ROUTES.SUBSCRIPTION.MAIN} element={<SubscriptionSettings />} />
        <Route path={config.ROUTES.BAN} element={<BannedAccountScreen />} />
      </Route>
    </Routes>
  );
}
